import { NOTE_DETAIL_LEVELS, NOTE_FORMAT_CHOICES } from '@/lib/noteStyle';
import { QuestionLabel } from '@/pages/onboarding/QuestionLabel';
import { SampleNote } from '@/pages/onboarding/SampleNote';
import type { OnboardingStepProps } from '@/pages/onboarding/onboarding.types';
import { matchOption } from '@/pages/onboarding/onboardingOptions';
import { SegmentedControl, Slider, Stack } from '@careflux/primitives';
import { Controller, useWatch } from 'react-hook-form';

export const DetailStep = ({ copy, control }: OnboardingStepProps) => {
  const [detail, format] = useWatch({ control, name: ['noteDetail', 'noteFormat'] });
  const detailMarks = NOTE_DETAIL_LEVELS.map((level, index) => ({ value: index, label: copy.detail.levels[level] }));

  return (
    <Stack as="section" gap="lg">
      <Controller
        name="noteDetail"
        control={control}
        render={({ field }) => (
          <Stack gap="sm">
            <QuestionLabel id="note-detail-label">{copy.detail.sliderLabel}</QuestionLabel>
            <Slider
              aria-labelledby="note-detail-label"
              min={0}
              max={NOTE_DETAIL_LEVELS.length - 1}
              step={1}
              marks={detailMarks}
              value={[NOTE_DETAIL_LEVELS.indexOf(field.value)]}
              onValueChange={([index]) => field.onChange(NOTE_DETAIL_LEVELS[index])}
            />
          </Stack>
        )}
      />
      <Controller
        name="noteFormat"
        control={control}
        render={({ field }) => (
          <Stack gap="sm">
            <QuestionLabel id="note-format-label">{copy.detail.formatLabel}</QuestionLabel>
            <SegmentedControl
              aria-labelledby="note-format-label"
              items={NOTE_FORMAT_CHOICES.map((value) => ({ value, label: copy.detail.formats[value] }))}
              value={field.value}
              onValueChange={(value) => {
                const next = matchOption(NOTE_FORMAT_CHOICES, value);
                if (next) field.onChange(next);
              }}
            />
          </Stack>
        )}
      />
      <SampleNote copy={copy.detail} detail={detail} format={format} />
    </Stack>
  );
};
